import React from "react";
import Heart from "../images/heart-lock.svg";
const SubscriptionAddItem = (props) => {
  const { model, join } = props;
  const callJoin = () => {
    join(model);
  };
  //model.site_url
  return (
    <div className="box_thumb">
      <div className="photo">
        <div className="wrap_image" onClick={callJoin}>
          <img
            src={`https://static.addfriends.com/images/friends/${model.site_url}.jpg`}
            alt={model.site_name}
          />
          <div className="tools">
            <img src={Heart} alt="Unlock Access" className="unlockme" />
            <div className="text">Join me now</div>
            <div className="cols">
              <div className="item">
                <i className="icon-empty-heart" />
                <span>890</span>
              </div>
              <div className="item">
                <i className="icon-eye" />
                <span>16.7k</span>
              </div>
              <div className="item">
                <i className="icon-star" />
                <span>40</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="content">
        <div className="row">
          <div className="name">
            <div className="sup">Friendname</div>
            <div className="sub">{model.site_name}</div>
          </div>
          <div className="sp_name">
            <div className="sup">Private Account</div>
            <button type="button" className="button_unlock" onClick={callJoin}>
              <b>
                <div className="col text-center">
                  <img src={Heart} alt="Unlock Access" className="unlockme" />
                  <span className="value">Unlock me</span>
                </div>
              </b>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionAddItem;
